import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { siteConfig } from '../config/site';

const navigation = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Our work', to: '/projects' },
  { label: 'Contact', to: '/contact' },
];

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="container header-inner">
        <Link className="brand" to="/" aria-label={`${siteConfig.organizationName} home`}>
          <span className="brand-mark" aria-hidden="true">○</span>
          <span>{siteConfig.organizationName}</span>
        </Link>
        <button
          className="menu-button"
          type="button"
          aria-expanded={isMenuOpen}
          aria-controls="primary-navigation"
          onClick={() => setIsMenuOpen((current) => !current)}
        >
          <span className="sr-only">Toggle navigation</span>
          <span aria-hidden="true">{isMenuOpen ? 'Close' : 'Menu'}</span>
        </button>
        <nav
          id="primary-navigation"
          className={`primary-navigation ${isMenuOpen ? 'is-open' : ''}`}
          aria-label="Primary navigation"
        >
          {navigation.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
              onClick={() => setIsMenuOpen(false)}
            >
              {item.label}
            </NavLink>
          ))}
          <Link className="button button-small" to="/contact" onClick={() => setIsMenuOpen(false)}>
            Support our work
          </Link>
        </nav>
      </div>
    </header>
  );
}
